<template>
  <div class="">
    <div class="container-screen">
      <div class="hmipantalla">
        <slot @open-keypad="openKeypad"></slot>
      </div>
    </div>
    <div class="pilotos">
      <HmiPiloto :label="'Bloqueo'" color="red" :is-on="pilotoBloqueo == '1' ? true : false">
      </HmiPiloto>
      <HmiPiloto :label="'Proceso'" color="green" :is-on="pilotoProceso == '1' ? true : false">
      </HmiPiloto>
      <HmiPiloto :label="'Prueba'" color="yellow" :is-on="pilotoPrueba == '1' ? true : false">
      </HmiPiloto>
      <HmiPiloto :label="'P. Emergencia'" color="red" :is-on="pilotoEmergencia == '1' ? true : false"></HmiPiloto>
    </div>
    <div class="botones">
      <HmiLlave :isOn="marcha == '1' ? true : false" :fondo="marchaFondo == '1' ? true : false"
        @click.native="escrituraAlternaIR(direccionVariablesBit.MARCHA_ESCRITURA, marcha)">
      </HmiLlave>
      <HmiButton label="RESET" width="30%" height="100%" :color="reset == '1'
        ? '#52CEFF'
        : '#00639C'" 
        @touchstart.native.prevent="escrituraMomentaneaIR(direccionVariablesBit.RESET_ESCRITURA, '1')"
        @touchend.native.prevent="escrituraMomentaneaIR(direccionVariablesBit.RESET_ESCRITURA, '0')"
        @mousedown.native="escrituraMomentaneaIR(direccionVariablesBit.RESET_ESCRITURA, '1')"
        @mouseup.native="escrituraMomentaneaIR(direccionVariablesBit.RESET_ESCRITURA, '0')">
      </HmiButton>
    </div>
  </div>
</template>

<script>
import HmiPiloto from "@/components/HMI/HmiPiloto.vue";
import HmiLlave from "@/components/HMI/HmiLlave.vue";
import HmiButton from "@/components/HMI/HmiButton.vue";

export default {
  name: "HmiPantalla",
  components: {
    HmiPiloto,
    HmiLlave,
    HmiButton,
  },

  computed: {
    numeroPantalla() {
      return this.$route.params.numeroPantalla;
    },

    direccionVariablesBit() {
      if (this.numeroPantalla == 1) {
        return {
          PILOTO_PROCESO_LECTURA: [144, 0],
          PILOTO_PRUEBA_LECTURA: [144, 1],
          PILOTO_BLOQUEO_LECTURA: [144, 2],
          PILOTO_EMERGENCIA_LECTURA: [144, 3],
          MARCHA_FONDO_LECTURA: [144, 4],
          MARCHA_LECTURA: [144, 5],
          MARCHA_ESCRITURA: ["Ir0050", 0],
          RESET_LECTURA: [144, 6],
          RESET_ESCRITURA: ["Ir0050", 1],
        };
      } else {
        return {
          PILOTO_PROCESO_LECTURA: [144, 7],
          PILOTO_PRUEBA_LECTURA: [144, 8],
          PILOTO_BLOQUEO_LECTURA: [144, 9],
          PILOTO_EMERGENCIA_LECTURA: [144, 10],
          MARCHA_FONDO_LECTURA: [144, 11],
          MARCHA_LECTURA: [144, 12],
          MARCHA_ESCRITURA: ["Ir0050", 2],
          RESET_LECTURA: [144, 13],
          RESET_ESCRITURA: ["Ir0050", 3],
        };
      }
    },

    pilotoBloqueo() {
      if (this.direccionVariablesBit) {
        let word =
          this.$store.state.lecturas[
          this.direccionVariablesBit.PILOTO_BLOQUEO_LECTURA[0]
          ];
        return this.obtenerBit(
          word,
          this.direccionVariablesBit.PILOTO_BLOQUEO_LECTURA[1]
        );
      }
      return "0";
    },
    pilotoProceso() {
      if (this.direccionVariablesBit) {
        let word =
          this.$store.state.lecturas[
          this.direccionVariablesBit.PILOTO_PROCESO_LECTURA[0]
          ];
        return this.obtenerBit(
          word,
          this.direccionVariablesBit.PILOTO_PROCESO_LECTURA[1]
        );
      }
      return "0";
    },
    pilotoPrueba() {
      if (this.direccionVariablesBit) {
        let word =
          this.$store.state.lecturas[
          this.direccionVariablesBit.PILOTO_PRUEBA_LECTURA[0]
          ];
        return this.obtenerBit(
          word,
          this.direccionVariablesBit.PILOTO_PRUEBA_LECTURA[1]
        );
      }
      return "0";
    },
    pilotoEmergencia() {
      if (this.direccionVariablesBit) {
        let word =
          this.$store.state.lecturas[
          this.direccionVariablesBit.PILOTO_EMERGENCIA_LECTURA[0]
          ];
        return this.obtenerBit(
          word,
          this.direccionVariablesBit.PILOTO_EMERGENCIA_LECTURA[1]
        );
      }
      return "0";
    },
    marchaFondo() {
      if (this.direccionVariablesBit) {
        let word =
          this.$store.state.lecturas[
          this.direccionVariablesBit.MARCHA_FONDO_LECTURA[0]
          ];
        return this.obtenerBit(
          word,
          this.direccionVariablesBit.MARCHA_FONDO_LECTURA[1]
        );
      }
      return "0";
    },
    marcha() {
      if (this.direccionVariablesBit) {
        let word =
          this.$store.state.lecturas[
          this.direccionVariablesBit.MARCHA_LECTURA[0]
          ];
        return this.obtenerBit(
          word,
          this.direccionVariablesBit.MARCHA_LECTURA[1]
        );
      }
      return "0";
    },
    reset() {
      if (this.direccionVariablesBit) {
        let word =
          this.$store.state.lecturas[
          this.direccionVariablesBit.RESET_LECTURA[0]
          ];
        return this.obtenerBit(
          word,
          this.direccionVariablesBit.RESET_LECTURA[1]
        );
      }
      return "0";
    },
  },

  methods: {
    obtenerBit(dato, posicion) {
      let intValue = parseInt(dato, 16);

      let binaryString = intValue.toString(2).padStart(16, "0");

      let bit = binaryString.charAt(binaryString.length - 1 - posicion);
      return bit;
    },
    escrituraAlternaIR(direccionEscritura, valor) {
      // Determinar la dirección y el número de bit desde direccionEscritura
      let direccion = direccionEscritura[0].substring(2);
      let bit = direccionEscritura[1];

      const nuevoValor = valor == "0" ? "1" : "0";

      // Construir el payload con el nuevo valor hexadecimal
      const payload = {
        name: "escrituraIR",
        direccion: direccion,
        valor: nuevoValor,
        bit: bit,
      };

      // Emitir el nuevo payload
      this.$parent.$emit("mandar-escritura", payload);
    },
    escrituraMomentaneaIR(direccionEscritura, valor) {
      // Determinar la dirección y el número de bit desde direccionEscritura
      let direccion = direccionEscritura[0].substring(2);
      let bit = direccionEscritura[1];

      // Construir el payload con el nuevo valor hexadecimal
      const payload = {
        name: "escrituraIR",
        direccion: direccion,
        valor: valor,
        bit: bit
      };
      // Emitir el nuevo payload
      this.$parent.$emit("mandar-escritura", payload);
    },
  },
};
</script>

<style scoped>
.hmipantalla {
  max-width: 950px;
  max-height: 750px;
  min-width: 400px;
  min-height: 300px;
  background-color: black;
  margin: auto;
  aspect-ratio: 4/3;
  border-radius: 10px;
  padding: 20px;
}

.container-screen {
  padding: clamp(0px, 10vw - 50px, 20px);
}

.pilotos {
  display: flex;
  justify-content: space-around;
  align-items: start;
  max-width: 950px;
  min-width: 400px;
  margin: auto;
  padding-top: 20px;
  height: 75px;
}

.botones{
  display: flex;
  padding-top: 10px;
  height: 75px;
  gap: 20px;
  max-width: 950px;
  min-width: 400px;
  justify-content: center;
}
</style>
